import styled from "styled-components";
import { useLocation } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import MenuFooterItem from "./menu/MenuFooterItem";

import facebookIcon from "assets/img/icons/icons8-facebook.svg";
import telegramIcon from "assets/img/icons/icons8-telegram-gray.svg";

const Footer = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;

  background-color: ${(props) => props.bgcolor};

  align-self: flex-end;
`;

const FooterLinks = styled.div`
  padding: 10px 0 30px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 40px 0 90px;
  }
`;

const FooterCopyright = styled.div`
  /* margin-bottom: 80px; */

  color: ${css.TEXT_GREY};
  font-family: "Barlow", sans-serif;
  font-size: 16px;
`;

const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const SocialIcon = styled.div`
  width: ${(props) => props.size};
  min-width: ${(props) => props.size};
  height: ${(props) => props.size};

  transform: ${(props) => (props.transform ? props.transform : "none")};
`;

export default () => {
  const location = useLocation();

  const { pathname } = location;
  const bgColor =
    pathname === "/" ||
    pathname === "/promo-mlm" ||
    pathname === "/promo-earn" ||
    pathname === "/promo-one"
      ? css.LANDING_PAGE_BACKGROUND
      : css.PAGE_BACKGROUND;

  return (
    <Footer bgcolor={bgColor}>
      <FooterLinks>
        <MenuFooterItem to="/">Home</MenuFooterItem>
        <MenuFooterItem to="https://help.scalelup.com/" target="_blank">
          Support
        </MenuFooterItem>
        <MenuFooterItem to="/terms">Terms</MenuFooterItem>
        <MenuFooterItem to="/privacy-policy">Privacy Policy</MenuFooterItem>
        <div
          onClick={() => {
            window.cookiehub.openSettings();
          }}
        >
          <MenuFooterItem to="#">Cookie Settings</MenuFooterItem>
        </div>
        <FooterCopyright>© 2026 Scalelup</FooterCopyright>
        <SocialIcons>
          <SocialIcon size="30px">
            <a href="https://www.facebook.com/scalelup" target="_blank">
              <img
                src={facebookIcon}
                style={{ width: "100%" }}
                alt="Facebook"
              />
            </a>
          </SocialIcon>
          <SocialIcon size="26px" transform="translateY(1px)">
            <a href="https://t.me/scalelupcom" target="_blank">
              <img
                src={telegramIcon}
                style={{ width: "100%" }}
                alt="Telegram"
              />
            </a>
          </SocialIcon>
        </SocialIcons>
      </FooterLinks>
    </Footer>
  );
};
